// extracted by mini-css-extract-plugin
export default {"container":"ConfirmPWResetAdmin_container__2JeCE"};